/**
 * Folds a string the way a search box should read it: case-insensitive and
 * accent-insensitive, so a diner typing "taqueria" finds "Taquería" and
 * "jalapeno" finds "jalapeño". Apply it to BOTH sides of a comparison — the
 * term and each candidate — or the fold is asymmetric and matching gets worse,
 * not better.
 *
 * `NFD` decomposes an accented letter into its base letter plus a combining
 * mark, and stripping those marks leaves the base letter behind. That includes
 * the tilde of ñ, which is not strictly an accent in Spanish — deliberate, and
 * it matches Postgres `unaccent`, which the server-side searches fold through
 * (app/queries/concerns/accent_insensitive_search.rb). Client-side filtering and
 * server-side search must never disagree about what matches the same term.
 */
export function normalizeForSearch(value: string): string {
  return value
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "")
    .toLowerCase()
}
